import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EOpenNewReviewForm } from './openFormActionsTypes';
import { trackOpenNewReviewForm } from '../../analytics/newReview';
import { getNewReviewFormStep } from '../../selectors/newReview';
import { ENewReviewModalStep } from '../../types/newReview';
import { setNewReviewFormStep } from './stepActionsTypes';
import { clearNewReviewFormAction } from './newReviewsAction';
import { getUserForAnalytics } from '../../selectors/user';

export const setNewReviewFormOpenAction = actionGenerator<EOpenNewReviewForm.Open>(EOpenNewReviewForm.Open);
export const setNewReviewFormCloseAction = actionGenerator<EOpenNewReviewForm.Close>(EOpenNewReviewForm.Close);

export function setNewReviewFormOpen(): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const user = getUserForAnalytics(state);

    trackOpenNewReviewForm({ user });
    dispatch(setNewReviewFormOpenAction());
  };
}

export function setNewReviewFormClose(): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const newReviewStep = getNewReviewFormStep(state);

    if (newReviewStep === ENewReviewModalStep.Success) {
      dispatch(setNewReviewFormStep(ENewReviewModalStep.Rating));
      dispatch(clearNewReviewFormAction());
    } else {
      dispatch(setNewReviewFormStep(ENewReviewModalStep.Rating));
    }

    dispatch(setNewReviewFormCloseAction());
  };
}
